var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 3.99999C1.6001 3.57565 1.76867 3.16868 2.06873 2.86862C2.36878 2.56856 2.77575 2.39999 3.2001 2.39999H8.8001C9.22444 2.39999 9.63141 2.56856 9.93147 2.86862C10.2315 3.16868 10.4001 3.57565 10.4001 3.99999V7.19999C10.4001 7.62434 10.2315 8.03131 9.93147 8.33136C9.63141 8.63142 9.22444 8.79999 8.8001 8.79999H7.2001L4.8001 11.2V8.79999H3.2001C2.77575 8.79999 2.36878 8.63142 2.06873 8.33136C1.76867 8.03131 1.6001 7.62434 1.6001 7.19999V3.99999Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.60001V7.20001C12.0001 8.0487 11.663 8.86263 11.0628 9.46275C10.4627 10.0629 9.6488 10.4 8.80011 10.4H7.86251L6.44971 11.8136C6.67371 11.9328 6.92891 12 7.20011 12H8.80011L11.2001 14.4V12H12.8001C13.2245 12 13.6314 11.8314 13.9315 11.5314C14.2315 11.2313 14.4001 10.8244 14.4001 10.4V7.20001C14.4001 6.77566 14.2315 6.36869 13.9315 6.06864C13.6314 5.76858 13.2245 5.60001 12.8001 5.60001H12.0001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAlt2);
export default __webpack_public_path__ + "static/media/ChatAlt2.4c01ebff4059ae17506f63341a468767.svg";
export { ForwardRef as ReactComponent };